import ReactDOM from 'react-dom/client'
import App from './App'
import './app/i18n'

import 'assets/styles/common.scss'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
)
